
export function initState() {

    return state
}

export function registerModule(path, module, callback, options) {
    return {
        beforeCreate () {
            if (!this.$store._modulesNamespaceMap[`${path}/`]){
                this.$store.registerModule(path, module, options);
            }

            const members = callback()

            this.$options.computed = Object.assign(this.$options.computed || {}, members.computed || {})
            this.$options.methods = Object.assign(this.$options.methods || {}, members.methods || {})
        },

        destoyed () {
            // this.$store.unregisterModule(path)
        }
    }
}